import React from "react";
import PropTypes from "prop-types";

import Context from "shared/util/Context";
import XAxisPixel from "routers/shared/components/XAxisPixel";
import ActionSignup from "routers/shared/components/ActionSignup";
import ActionPartialSignup from "routers/shared/components/ActionPartialSignup";
import usePingdom from "routers/shared/hooks/usePingdom";
import useGoogleRemarketing from "routers/shared/hooks/useGoogleRemarketing";
import useGoogleAdwords from "routers/shared/hooks/useGoogleAdwords";
import useGoogleAnalytics from "routers/shared/hooks/useGoogleAnalytics";
import useFacebookPixel from "routers/shared/hooks/useFacebookPixel";
import useKruxTracking from "routers/shared/hooks/useKruxTracking";
import useMParticle from "routers/shared/hooks/useMParticle";
import useSiftScience from "routers/shared/hooks/useSiftScience";
import { useDeviceFingerprint } from "shared/util/deviceId";

const TrackingCenter = ({ location }) => {
	// The context we rely on, for now.
	const userid = Context.get("userid");
	const {
		gender,
		age,
		metro_area: metroArea,
	} = Context.get("user_demo") || {};
	const adFree = Context.get("adFree");
	const analyticsAttributes = Context.get("analyticsAttributes");
	const kruxData = Context.get("kruxData");

	useDeviceFingerprint();
	usePingdom();
	useGoogleRemarketing();
	useGoogleAdwords({ location });
	useGoogleAnalytics({ userid, metroArea, location, kruxData });
	useFacebookPixel({ location });
	useKruxTracking({ adFree });
	useMParticle({ userid, location, analyticsAttributes });
	useSiftScience({ userid });

	return (
		<>
			<ActionSignup location={location} />
			<ActionPartialSignup location={location} />
			<XAxisPixel
				isLoggedIn={!!userid}
				gender={gender}
				age={age}
			/>
		</>
	);
};

TrackingCenter.propTypes = {
	location: PropTypes.object.isRequired,
};

export default TrackingCenter;



// WEBPACK FOOTER //
// ./src/routers/shared/components/TrackingCenter.jsx